<div class="page-content">
  <div class="content-box">

    <img src="assets/logo-solusoft.jpg" alt="SoluSoft SPA" class="logo" />

    <h1>Contacto</h1>

    <p class="intro">
      ¿Tienes alguna consulta, proyecto o necesitas asesoría tecnológica?
      En <strong>Soluprime</strong> estaremos encantados de ayudarte.
    </p>

    <div class="contact-info">
      <p>
        <strong>Correo:</strong>
        <a href="mailto:contacto@solusoftspa.cl">contacto@solusoftspa.cl</a>
      </p>

      <p>
        <strong>Teléfono:</strong>
        <a href="tel:+56993979712">+56 9 9397 9712</a>
      </p>

      <p>
        <strong>Ubicación:</strong> Puente Alto, Santiago
      </p>
    </div>

    <!-- BOTÓN WHATSAPP -->
    <div class="whatsapp-box">
      <a
  href="https://wa.me/56993979712?text=Hola%20Soluprime,%20vi%20su%20sitio%20web%20y%20me%20interesa%20conocer%20sus%20soluciones.%20%C2%BFPodr%C3%ADan%20brindarme%20m%C3%A1s%20informaci%C3%B3n%3F"
  target="_blank"
  class="whatsapp-btn"
>
  💬 Contactar por WhatsApp
</a>
      
    </div>

  </div>
</div>
